import {useUserState} from "../store/user-store";

const useCurrentUser = () => {
    const user = useUserState((state) => state.currentUser);
    return { currentUser: user };
};

export default useCurrentUser;
